import type { CSSProperties, ReactNode } from "react";

/**
 * Campo de formulário validado (Design.md §7 / §9): rótulo visível, marca `*`
 * em obrigatórios, mensagem de erro curta em laranja próxima ao campo (§10).
 */
export interface FieldProps {
  label: ReactNode;
  children: ReactNode;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  hint?: ReactNode;
  style?: CSSProperties;
}

export function Field({
  label,
  children,
  htmlFor,
  required = false,
  error,
  hint,
  style
}: FieldProps): ReactNode {
  const labelStyle: CSSProperties = {
    fontSize: 12,
    fontWeight: 700,
    color: "var(--text)"
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.3rem",
        ...(style ?? {})
      }}
    >
      {htmlFor === undefined ? (
        <span style={labelStyle}>
          {label}
          {required ? <RequiredMark /> : null}
        </span>
      ) : (
        <label htmlFor={htmlFor} style={labelStyle}>
          {label}
          {required ? <RequiredMark /> : null}
        </label>
      )}
      {children}
      {hint !== undefined ? (
        <span style={{ fontSize: 11.5, color: "var(--text-muted)" }}>{hint}</span>
      ) : null}
      {error !== undefined ? <FormError>{error}</FormError> : null}
    </div>
  );
}

function RequiredMark(): ReactNode {
  return (
    <span aria-hidden style={{ color: "var(--orange)", marginLeft: 2 }}>
      *
    </span>
  );
}

export interface FormErrorProps {
  children: ReactNode;
}

export function FormError({ children }: FormErrorProps): ReactNode {
  return (
    <span role="alert" style={{ fontSize: 11.5, color: "var(--orange)", fontWeight: 600 }}>
      {children}
    </span>
  );
}
